import { useEffect, useState } from "react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { toast } from "react-toastify";
import { Post } from "../services/api";
import { symbol } from "zod";
import { Decimal_util } from "../../utils/Dec.util";
import { eventBus } from "../../utils/eventbus.util";
import { ref } from "yup";

const BuyBoxHtml = ({
  firstCoin,
  secondCoin,
  marketSellPrice,
  initialPrice,
  refresh,
  refreshPage,
  socket,
}) => {
  const [balance, set_balance] = useState(0);

  const [priceDecimal, set_priceDecimal] = useState(0);
  const [quantityDecimal, set_quantityDecimal] = useState(0);

  const [side, set_side] = useState("Buy");

  const [type, set_type] = useState("Limit");

  const [marketPrice, set_marketPrice] = useState(0);
  const [limitPrice, set_limitPrice] = useState(0);

  const [amount, set_amount] = useState(0);

  const [tradeAmount, set_tradeAmount] = useState(0);
  const [netAmount, set_netAmount] = useState(0);
  const [tradeFee, set_tradeFee] = useState(0);
  const [bPBtn, setBPBtn] = useState(0);

  const [loader, set_loader] = useState(false);

  const calculate_net_amount = (amount, price) => {
    console.log(amount, price);

    price = price || 0;
    amount = amount || 0;

    const tradeamount = Decimal_util.operation(amount, "mul", price);

    const feesamount = Decimal_util.operation(
      tradeamount,
      "mul",
      Decimal_util.operation(tradeFee, "div", 100)
    );

    set_netAmount(Decimal_util.operation(tradeamount, "add", feesamount));
    set_tradeAmount(tradeamount);
  };

  useEffect(() => {
    if (initialPrice > 0) {
      set_limitPrice(initialPrice.replace(/(\.\d*?)0+$/, "$1"));
    }
    
  }, [initialPrice]);

  const handler = ({ quantity, price }) => {
    set_limitPrice(price);
    set_amount(quantity);

    console.log(quantity, price, "buy event come");
  };

  useEffect(() => {
    eventBus.on("buyEvent", handler);

    // Cleanup listener on unmount
    return () => {
      eventBus.off("buyEvent", handler);
    };
  }, []);

  useEffect(() => {
    set_loader(false);
  }, [refresh]);

  const handleSubmit = (e) => {
    e.preventDefault();

    let temp_price;
    if (type === "Market") {
      if (marketPrice < 0) {
        toast.error("Price cannot be zero");
        return;
      }
      temp_price = marketPrice;
    } else {
      if (limitPrice <= 0) {
        toast.error("Price cannot be zero");
        return;
      }
      temp_price = limitPrice;
    }

    if (amount <= 0) {
      toast.error("Please enter a valid amount");
      return;
    }


    // if(Number(netAmount)<Number(balance)){
    //   toast.dismiss();
    //   toast.error("Insufficient balance on front");
    //    return
    // }

    const payload = {
      side: side.toUpperCase(),
      type: type.toUpperCase(),
      price: Number(temp_price),
      quantity: Number(amount),
      pair: `${firstCoin}/${secondCoin}`, // backend expects "BTC/USDT" format
    };

    if (type.toUpperCase() == "MARKET") {
      delete payload.price;
    }

    set_loader(true);

    // Assuming you already have socket connection stored in state/context
    socket.emit("create_order", payload, (response) => {
      if (response.status) {
        set_amount(0);
        set_netAmount(0);
        set_tradeAmount(0);
        refreshPage();

        // if (response.show) {
        //   toast.success(response.message);
        // } else {
        //   toast.success("Order created successfully");
        // }
      } else {
        set_loader(false);
        toast.error(response.message || "Failed to create order");
      }
    });
  };

  useEffect(() => {
    if (
      localStorage.getItem("jwtToken") &&
      firstCoin.length &&
      secondCoin.length
    ) {
      socket.emit(
        "get_balance_for_pair", // <-- You must have this event in backend
        { pair: `${firstCoin.toLowerCase()}${secondCoin.toLowerCase()}` },
        (res) => {          
          if (res?.status) {
            set_balance(res.data.sell_balance);
          } else {
            toast.error(res?.message || "Failed to load tabs");
          }
        }
      );

      socket.emit(
        "get_pair_commission", // <-- You must have this event in backend
        { pair: `${firstCoin.toLowerCase()}${secondCoin.toLowerCase()}` },
        (res) => {          
          if (res?.status) {
            set_tradeFee(res.data.buy);
            set_priceDecimal(res.data.pricePrecision);
            set_quantityDecimal(res.data.quantityPrecision);
          } else {
            toast.error(res?.message || "Failed to load tabs");
          }
        }
      );
    }
  }, [firstCoin, secondCoin, refresh]);

  const handleBuyPercent = (per) => {
    setBPBtn(per);
    console.log();

    const temp_balance = Decimal_util.operation(
      balance,
      "mul",
      Decimal_util.operation(per, "div", 100)
    );

    let amount;

    if (type == "Market") {
      if (tradeFee > 0) {
        const temp_balance2 = Decimal_util.operation(
          Decimal_util.operation(temp_balance, "mul", 100),
          "div",
          Decimal_util.operation(100, "add", tradeFee)
        );

        amount = Decimal_util.fixedtillString(
          Decimal_util.operation(temp_balance2, "div", marketSellPrice),
          quantityDecimal
        );
      } else {
        amount = Decimal_util.fixedtillString(
          Decimal_util.operation(temp_balance, "div", marketSellPrice),
          quantityDecimal
        );
      }
    } else {
      if (limitPrice > 0) {
        if (tradeFee > 0) {
          // Calculate the amount of BNB user will receiv
          const temp_balance2 = Decimal_util.operation(
            Decimal_util.operation(temp_balance, "mul", 100),
            "div",
            Decimal_util.operation(100, "add", tradeFee)
          );

          amount = Decimal_util.fixedtillString(
            Decimal_util.operation(temp_balance2, "div", limitPrice),
            quantityDecimal
          );
        } else {
          amount = Decimal_util.fixedtillString(
            Decimal_util.operation(temp_balance, "div", limitPrice),
            quantityDecimal
          );
        }
      } else {
        set_amount(0);
        calculate_net_amount(0, 0);
      }
    }

    set_amount(amount);
    if (type == "Market") {
      calculate_net_amount(amount, marketSellPrice);
    } else {
      calculate_net_amount(amount, limitPrice);
    }
  };

  useEffect(() => {
    if (type == "Market") {
      set_marketPrice(marketSellPrice);
      calculate_net_amount(amount, marketSellPrice);
    }
  }, [marketSellPrice]);

  const handlePriceChange = (event) => {
    let value = event.target.value;

    console.log(value);
    // Prevent negative values
    if (parseFloat(value) < 0 || isNaN(value)) {
      return; // Do nothing if it's a negative value
    }

    if (value.split(".").length == 2) {
      let [integerPart, decimalPart] = value.split(".");

      if (decimalPart.length > priceDecimal) {
        return;
      }
    }
    // Allow only 8 digits before the decimal and 8 digits after the decimal

    calculate_net_amount(amount, value);
    set_limitPrice(value);
  };
  const handleAmountChange = (event) => {
    let value = event.target.value;
    // Prevent negative values

    // Prevent negative values (optional, depending on your requirements)
    if (parseFloat(value) < 0 || isNaN(value)) {
      return; // Do nothing if it's a negative value
    }

    if (value.split(".").length == 2) {
      let [integerPart, decimalPart] = value.split(".");

      if (decimalPart.length > quantityDecimal) {
        return;
      }
    }

    console.log(value);
    // Allow only 8 digits before the decimal and 8 digits after the decimal

    if (type == "Market") {
      calculate_net_amount(value, marketPrice);
    } else {
      calculate_net_amount(value, limitPrice);
    }
    set_amount(value);
  };
  return (
    <div className="buy-btc-outer buy-sell-outer border1">
      <div className="orderforms-hd">
        <div>
          <label className="ng-binding ">Buy {firstCoin}</label>
          <span className="f-fr ng-binding">
            {secondCoin} : {Decimal_util.fixedtillString(balance, 8) || 0}
          </span>
        </div>
      </div>
      <ul className="type-list-outer d-flex justify-content-between">
        <li className="cursor-pointer">
          <a
            onClick={() => {
              set_type("Limit");
              calculate_net_amount(amount, limitPrice);
            }}
            className={type === "Limit" ? "active" : " "}
          >
            Limit
          </a>
        </li>
        <li className="cursor-pointer">
          <a
            onClick={(e) => {
              set_type("Market");
              set_marketPrice(marketSellPrice);
              calculate_net_amount(amount, marketSellPrice);
            }}
            className={type === "Market" ? "active" : ""}
          >
            Market
          </a>
        </li>
      </ul>
      <form
        name="buyForm"
        onSubmit={handleSubmit}
        autoComplete="off"
        className="ng-pristine ng-invalid ng-invalid-required"
      >
        <div className="orderforms-inputs ">
          <div className="field f-cb">
            <label className="ng-binding">Price: </label>
            <div className="iptwrap leftBig">
              {type === "Market" ? (
                <>
                  <input
                    type="text"
                    step="any"
                    id="pric"
                    value={marketPrice}
                    name="buyPrice"
                    className="ng-pristine ng-untouched ng-not-empty ng-valid ng-valid-required"
                    disabled={true}
                  />
                  <span className="unit ng-binding">{secondCoin}</span>
                </>
              ) : (
                <>
                  <input
                    type="text"
                    step="any"
                    id="price_buy"
                    value={limitPrice}
                    onChange={handlePriceChange}
                    name="buyPrice"
                    className="ng-pristine ng-untouched ng-not-empty ng-valid ng-valid-required"
                  />
                  <span className="unit ng-binding">{secondCoin}</span>
                </>
              )}
            </div>
            <div className="cls"></div>
          </div>
          <div className="field f-cb">
            <label className="ng-binding">Amount: </label>
            <div className="iptwrap">
              <input
                type="text"
                step="any"
                name="buyAmount"
                onChange={handleAmountChange}
                value={amount}
                id="buyAmount"
                aria-invalid="true"
              />
              <span className="unit ng-binding">{firstCoin}</span>
            </div>
            <div className="cls"></div>
          </div>
          {/* <div className="field percent f-cb">
            <div className="field4">
              <span
                className={`col ${bPBtn == 25 ? "my_color_buy" : ""}`}
                onClick={() => handleBuyPercent(25)}
              >
                25
              </span>
              <span
                className={`col ${bPBtn == 50 ? "my_color_buy" : ""}`}
                onClick={() => handleBuyPercent(50)}
              >
                50
              </span>
              <span
                className={`col ${bPBtn == 75 ? "my_color_buy" : ""}`}
                onClick={() => handleBuyPercent(75)}
              >
                75
              </span>
              <span
                className={`col ${bPBtn == 100 ? "my_color_buy" : ""}`}
                onClick={() => handleBuyPercent(100)}
              >
                100
              </span>
            </div>
          </div> */}
          <div className="field f-cb">
            {type === "Market" ? (
              <>
                <label className="ng-binding">Total: </label>
                <div className="iptwrap">
                  <input
                    type="number"
                    step="any"
                    id="total_buy"
                    name="buy_order_total"
                    value={tradeAmount}
                    disabled
                    className="ng-pristine ng-untouched ng-valid ng-empty"
                  />
                  <span className="unit ng-binding">{secondCoin}</span>
                </div>
              </>
            ) : (
              <>
                <label className="ng-binding">Total: </label>
                <div className="iptwrap">
                  <input
                    type="number"
                    step="any"
                    id="total_buy"
                    name="buy_order_total"
                    value={tradeAmount}
                    disabled
                    className="ng-pristine ng-untouched ng-valid ng-empty"
                  />
                  <span className="unit ng-binding">{secondCoin}</span>
                </div>
              </>
            )}
            <div className="cls"></div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <p style={{ fontSize: 10 }} className="ng-binding">
                Trade Fee :{tradeFee} %
              </p>
              <p style={{ fontSize: 10 }} className="ng-binding">
                {/* Net Amount : {netAmount} */}
              </p>
            </div>
          </div>
          {AuthAction(loader)}
        </div>
      </form>
    </div>
  );
};

const AuthAction = (loader) => {
  if (localStorage.getItem("jwtToken")) {
    return (
      <button
        className="btn w100  my_color_buy"
        type="submit"
        disabled={loader}
      >
        Buy
      </button>
    );
  } else {
    return (
      <div className="orderforms-inputs">
        <div className="border2 p-2 tc">
          <Link to="/register">Sign Up</Link> or{" "}
          <Link to="/login">Login</Link>
        </div>
      </div>
    );
  }
};

export { BuyBoxHtml };
